import React, { Fragment, useState } from 'react';
import { getApiPageVerificationUrl, getApiPageVerificationsUrl } from '../../utilities/urlHelper';
import { canVerifyPage } from '../../utilities/permissionsUtilities';

const VerifyContainer = ({ assignees, page, onSubmit }) => {
    const [submitting, setSubmitting] = useState(false);
    const [verificationId, setVerificationId] = useState(null);
    const [pageId, setPageId] = useState(page.id ?? null);
    const [revisionId, setRevisionId] = useState(page.revision_id ?? null);

    if (!(page && page.id && page.verification_schedule_id)) {
        return null;
    }

    // only page verification assignees & admins can verify
    if (!(canVerifyPage() || (assignees.includes(window.userId)))) {
        return null;
    }

    const verifyClass = verificationId ? '' : '';
    const submittingClass = submitting ? 'muted' : '';
    const verifyText = submitting
        ? 'Submitting...'
        : verificationId
            ? 'Undo'
            : ' Verify page content';

    const toggleVerification = () => {
        if (submitting) {
            return;
        }
        setSubmitting(true);

        const url = verificationId
            ? getApiPageVerificationUrl(pageId, verificationId)
            : getApiPageVerificationsUrl(pageId);
        const method = verificationId ? 'DELETE' : 'POST';

        const data = verificationId ? '' : { revision_id: revisionId };

        $.ajax({
            type: method,
            url,
            data,
        }).done((response) => {
            if (response.success) {
                if (response.page_verification) {
                    onSubmit(response.page_verification);
                    return setVerificationId(response.page_verification);
                }
                onSubmit(null);
                return setVerificationId(null);
            }
        }).catch(console.error)
            .always(() => {
                setSubmitting(false);
            });
    };

    return (
        <Fragment>
            {verificationId
            && (
                <Fragment>
                    <span role="img" aria-hidden="true">✔️</span>
                    <span>Content verified!</span>
                </Fragment>
            )}
            <button
                className={`message-btn ${verifyClass} ${submittingClass}`}
                type="button"
                onClick={toggleVerification}
            >
                {!verificationId
                && <span role="img" aria-hidden="true">✔️</span>}
                {verifyText}
            </button>
        </Fragment>
    );
};
export default VerifyContainer;
